export class BasePaymentMethodManager {
  addEventListener(event: string, handler: (...args: any[]) => void) {
    throw new Error('Method not implemented.');
  }
}
